import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '' }) => {
  const siteName = 'Speaking Mirror';
  const siteUrl = 'https://www.speakingmirror.in';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Marketing Agency`;
  const defaultDesc = 'Full-scale marketing agency specializing in Digital Marketing & Content Creation. 500+ brands. Kolkata | Mumbai | Dubai.';
  const desc = description || defaultDesc;
  const image = 'https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/c3g6j18u_SM.png';
  const canonicalUrl = path ? `${siteUrl}${path}` : siteUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
